module.exports = "<plan-form-assets plan=\"maintenancePlanData\"></plan-form-assets>\r\n";